export const isIOS = (): boolean => /iPad|iPhone|iPod/.test(navigator?.userAgent);

export const isAndroid = (): boolean => /(Android)/.test(navigator?.userAgent);
